import React, { useEffect } from 'react';

import styled from '@emotion/styled';

import {
  Box,
  COLORS,
  InfoModal,
  MEDIUM_TITLE_STYLES,
  Text,
} from '@clutter/clean';

import { useTrack } from '@root/initializers/wt';

import { FunnelEntryPoint } from '@shared/funnel_entry_point';
import { FunnelEntryPointForm } from '@shared/funnel_entry_point_form';
import { FunnelEntryPointErrorMessage } from '@shared/funnel_entry_point_message';
import { FunnelEntryPointSubmitButton } from '@shared/funnel_entry_point_submit_button';
import { FunnelEntryPointZipInput } from '@shared/funnel_entry_point_zip_input';

const Error = styled(Text.Caption)`
  color: ${COLORS.toucan};
  text-align: center;
`;

type FormProps = {
  id: string;
  wtConfig: {
    container: string;
    label: string;
    [metadataKey: string]: string;
  };
};

const Form: React.FC<FormProps> = ({ id, wtConfig }) => (
  <FunnelEntryPoint wtConfig={wtConfig}>
    <Box textAlign="center" margin="0 0 24px">
      <Text color={COLORS.tealDark} style={MEDIUM_TITLE_STYLES.LG}>
        Get pricing
      </Text>
    </Box>
    <FunnelEntryPointForm id={id}>
      <Box.Flex flexDirection="column" gap="16px">
        <FunnelEntryPointZipInput />

        <FunnelEntryPointErrorMessage
          render={(errorMessage) => (
            <Box margin="-8px 4px 12px">
              <Error>{errorMessage}</Error>
            </Box>
          )}
        />
        <FunnelEntryPointSubmitButton />
        <Box textAlign="center">
          <Text.Callout color={COLORS.storm}>In under 2 minutes!</Text.Callout>
        </Box>
      </Box.Flex>
    </FunnelEntryPointForm>
  </FunnelEntryPoint>
);

export const ServiceSelectorModal: React.FC<
  {
    isOpen: boolean;
    onClose: () => void;
  } & FormProps
> = ({ isOpen, onClose, ...formProps }) => {
  const track = useTrack();

  useEffect(() => {
    if (isOpen) {
      track({
        action: 'click',
        objectName: 'cta',
        objectType: 'button',
        ...formProps,
      });
    }
  }, [isOpen]);

  const handleModalClose = () => {
    onClose();
  };

  return (
    <InfoModal isOpen={isOpen} handleModalClose={handleModalClose}>
      <Form {...formProps} />
    </InfoModal>
  );
};
